import { setDays } from '../State/newProjectsWithOrderReport';
import fetchNewOrdersReport from '../Services/fetchNewProjectsWithOrderReport';

export default (value) => async (dispatch) => {
  dispatch(setDays(value));
  dispatch(fetchNewOrdersReport());
}
